import request from "@form/utils/request";

export const getAuthLink = async (): Promise<{
  authLink: string;
}> => {
  return await request.rpc("sendingme/authlink", {});
};
